import { MONDAY_FULL_CLIENTS } from "@/lib/integration/monday";
import {
  getMondayItemByColumnValue,
  updateMondayItem,
} from "@/lib/integration/monday/common";

export enum MondayPlatformStatus {
  REVIEW_EXPERIENCE = "%ReviewExperience",
  COMPLETE_EXPERIENCE = "%CompleteExperience",
  BOOSTING_EXPERIENCE = "%BoostingExperience",
  REVIEW_POTENTIAL_REFS = "%ReviewPotentialRefs",
  REVIEW_REFS_CHOICE = "%ReviewRefsChoice",
  COMPLETE_REFS_CHOICE = "%CompleteRefsChoice",
  COMPLETE_DETAILED_REF = "%CompleteDetailedRef",
  SEND_FEEDBACK = "%SendExperienceFeedback",
  SEND_REFS_FEEDBACK = "%SendRefsFeedback",
  WITHOUT_DETAILS = "%WithoutDetails",
}

export const prepareMondayPlatformStatus = (
  itemName: string,
  command: MondayPlatformStatus
): string => {
  // Replace "%" delimeter, it's reserved for parsing string in Monday automations
  itemName = itemName.replace("%", "percent");
  return `${itemName}${command}`;
};

export const updateMondayFetItemPlatformStatus = async (
  mondayClientItemId: string | null,
  mondayPlatformStatus: string
): Promise<void> => {
  if (mondayClientItemId === null) {
    console.info(
      "mondayClientItemId is null, so skipping updateMondayFetItemPlatformStatus request"
    );
    return;
  }

  const mondayItem = await getMondayItemByColumnValue(
    MONDAY_FULL_CLIENTS.ID,
    MONDAY_FULL_CLIENTS.COLS.CLIENT_ID,
    mondayClientItemId
  );

  if (mondayItem === null) {
    return;
  }
  const mondayItemId = mondayItem.id;

  await updateMondayItem(MONDAY_FULL_CLIENTS.ID, mondayItemId, {
    [MONDAY_FULL_CLIENTS.COLS.STATUS]: mondayPlatformStatus,
  });
};
